import React, { useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AuthContext from "../../context/auth/authContext";
import TripContext from "../../context/trip/tripContext";
import TripItem from "../trips/TripItem";

const DestinationTrips = () => {
  const { destination_id } = useParams();
  const history = useHistory();

  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;

  const tripContext = useContext(TripContext);
  const { getTripsForDestination, trips, loading } = tripContext;

  useEffect(() => {
    loadUser();
    getTripsForDestination(destination_id);
    // eslint-disable-next-line
  }, [destination_id]);

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Button
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
        onClick={() => history.push('/destinations')}
        sx={{
          textTransform: 'none',
          color: 'text.secondary',
          fontWeight: 500,
          mb: 2,
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        Back to Discover
      </Button>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Trips
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Browse trips shared by travelers who visited this destination.
        </Typography>
      </Box>
      {loading ? (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>Loading...</Typography>
      ) : trips && trips.length > 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {trips.map((trip) => (
            <TripItem key={trip.id} trip={trip} showButton={true} fromPath={`/destination/${destination_id}`} />
          ))}
        </Box>
      ) : (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>No trips for this destination yet.</Typography>
      )}
    </Box>
  );
};

export default DestinationTrips;
